import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import flash from "../lib/flashes.js"

export default class extends Controller {
  static targets = ["container", "handle", "item"]

  connect() {
    if (this.hasContainerTarget) {
      this.initializeSortable()
    }
  }

  initializeSortable() {
    this.sortable = new Sortable(this.containerTarget, {
      handle: ".fa-grip-vertical",
      animation: 150,
      onEnd: this.updateOrder.bind(this)
    })
  }

  async updateOrder(event) {
    const items = this.itemTargets
    const positions = items.map((item, index) => ({
      id: item.dataset.id,
      position: index + 1
    }))

    return fetch(this.element.dataset.updateUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ positions: positions })
    }).then(response => {
      if (response.ok) {
        flash("Positions updated", "success")
        return
      }

      return response.text().then((body) => {
        console.error("[asset-layout-sorter] Failed to save field order:", response.status, body || "(no body)")
        flash("Could not save order", "error")
      }).catch(() => {
        console.error("[asset-layout-sorter] Failed to save field order:", response.status)
        flash("Could not save order", "error")
      })
    }).catch((err) => {
      console.error("[asset-layout-sorter] Request failed:", err)
      flash("Something went wrong", "error")
    })
  }
}
